module.exports = __webpack_public_path__ + "img/confirmation-icon.0439bb5a.svg";